import React,{createContext,useState} from 'react'
export const FilterContext = createContext({})

function FilterProvider({children}){

    const [search,setSearch] = useState()

    const getSearch = async (value) => {

        setSearch(value)        
    }


    
    return(
    <FilterContext.Provider value={{getSearch,search}}>
        {children}
    </FilterContext.Provider>
    )

}

export default FilterProvider